var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.077.839h.423a.83.83 0 0 0-.257-.6.87.87 0 0 0-1.19-.008L6 4.004 1.947.23A.87.87 0 0 0 .757.24a.827.827 0 0 0 .009 1.206L5.41 5.77a.87.87 0 0 0 1.18 0l4.644-4.324A.829.829 0 0 0 11.5.84h-.423z",
    fill: "#77928B",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.4cd45f659138b35b4a4fbef42f202c6b.svg";
export { ForwardRef as ReactComponent };